import { render } from "./BulbColor.vue?vue&type=template&id=f682605e&scoped=true"
import script from "./BulbColor.vue?vue&type=script&lang=js"
export * from "./BulbColor.vue?vue&type=script&lang=js"

import "./BulbColor.vue?vue&type=style&index=0&id=f682605e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f682605e"]])

export default __exports__